import { Injectable } from "@angular/core";
import { IBlackButton } from "@app/shared/models/iBlackButton";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BlackButtonService {
  data = new Subject<IBlackButton>();
}
